document.addEventListener('DOMContentLoaded', () => {

  const form = document.querySelector('.hb-contact-form');

  if (!form) return;

  const inputs = form.querySelectorAll('input, textarea');

  /* =========================
     Floating Focus Class
  ========================= */

  inputs.forEach(input => {

    input.addEventListener('focus', () => {
      input.parentElement.classList.add('active');
    });

    input.addEventListener('blur', () => {

      if (input.value.trim() === '') {
        input.parentElement.classList.remove('active');
      }

    });

  });

  /* =========================
     Simple Validation
  ========================= */

  form.addEventListener('submit', function(e){

    let valid = true;

    const required = form.querySelectorAll('[required]');

    required.forEach(field => {

      field.style.borderColor = '#d9ddd6';

      if(field.value.trim() === ''){

        valid = false;
        field.style.borderColor = '#d9534f';

      }

    });

    if(!valid){

      e.preventDefault();

      alert('Please fill in all required fields.');

      return;

    }

  });

  /* =========================
     Smooth Scroll Animation
  ========================= */

  const observer = new IntersectionObserver((entries)=>{

    entries.forEach(entry=>{

      if(entry.isIntersecting){

        entry.target.classList.add('show');

      }

    });

  },{
    threshold:0.15
  });

  document.querySelectorAll('.hb-feature').forEach(item=>{

    item.classList.add('fade-up');

    observer.observe(item);

  });

  const leftPanel = document.querySelector('.hb-contact-left');

  if(leftPanel){

    leftPanel.classList.add('fade-up');

    observer.observe(leftPanel);

  }

  const rightPanel = document.querySelector('.hb-contact-right');

  if(rightPanel){

    rightPanel.classList.add('fade-up');

    observer.observe(rightPanel);

  }

});
